import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function RegisterModal() {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const { register, reset, handleSubmit, errors, getValues } = useForm();

  const onSubmit = (value) => {
    axios.post("/api/seeker/register", value).then((response) => {
      enqueueSnackbar(response.data.message, { variant: response.data.status });
      if (response.data.status === "success") {
        reset();
        $("#sign_up_popup").modal("hide");
        history.push("/login");
      }
    });
  };

  return (
    <div
      className="modal fade sf-register-modal"
      id="sign_up_popup"
      aria-hidden="true"
      aria-labelledby="sign_up_popupLabel"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content sf-register-content">

          {/* ── Close ── */}
          <button
            type="button"
            className="btn-close sf-register-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>

          <div className="sf-register-layout">

            {/* ── Left – Illustration ── */}
            <div className="sf-register-img-panel">
              <figure>
                <img src="/portal/images/login.png" alt="Register illustration" />
              </figure>
            </div>

            {/* ── Right – Form ── */}
            <div className="sf-register-form-panel">
              <div className="twm-log-reg-form-wrap">

                <h2 className="wt-title">Welcome to Solid Future</h2>
                <p className="twm-log-reg-subtitle">
                  Boost your hiring success with a streamlined and user friendly job application system.
                </p>

                {/* ── Login / Register tabs ── */}
                <div className="radio_tabs">
                  <ul>
                    <li
                      data-bs-dismiss="modal"
                      data-bs-target="#sign_up_popup2"
                      data-bs-toggle="modal"
                      style={{ cursor: "pointer" }}
                    >
                      <span className="tab-dot"></span>
                      Login
                    </li>
                    <li className="active-tab">
                      <span className="tab-dot active-dot"></span>
                      Register
                    </li>
                  </ul>
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>

                  {/* Full Name */}
                  <div className="form-group mb-3">
                    <label className="twm-field-label">
                      Full Name <span className="sf-required">*</span>
                    </label>
                    <input
                      name="full_name"
                      type="text"
                      className={`form-control ${errors.full_name ? "is-invalid" : ""}`}
                      ref={register({ required: "Full name is required" })}
                    />
                    {errors.full_name && (
                      <div className="text-danger sf-field-error">{errors.full_name.message}</div>
                    )}
                  </div>

                  {/* Email */}
                  <div className="form-group mb-3">
                    <label className="twm-field-label">
                      Email <span className="sf-required">*</span>
                    </label>
                    <input
                      name="email"
                      type="email"
                      className={`form-control ${errors.email ? "is-invalid" : ""}`}
                      ref={register({
                        required: "Email is required.",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address",
                        },
                      })}
                    />
                    {errors.email && (
                      <div className="text-danger sf-field-error">{errors.email.message}</div>
                    )}
                  </div>

                  {/* Phone Number */}
                  <div className="form-group mb-3">
                    <label className="twm-field-label">
                      Phone Number <span className="sf-required">*</span>
                    </label>
                    <input
                      name="mobile"
                      type="number"
                      className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                      ref={register({
                        required: "Phone number is required",
                        minLength: { value: 10, message: "Must be 10 digits" },
                        maxLength: { value: 10, message: "Must be 10 digits" },
                      })}
                    />
                    {errors.mobile && (
                      <div className="text-danger sf-field-error">{errors.mobile.message}</div>
                    )}
                  </div>

                  {/* Password */}
                  <div className="form-group mb-3 position-relative">
                    <label className="twm-field-label">
                      Password <span className="sf-required">*</span>
                    </label>
                    <input
                      name="password"
                      type={showPass ? "text" : "password"}
                      className={`form-control ${errors.password ? "is-invalid" : ""}`}
                      ref={register({
                        required: "Password is required",
                        minLength: { value: 8, message: "Minimum 8 characters" },
                      })}
                    />
                    <span className="showPassword" onClick={() => setShowPass(!showPass)}>
                      <i className={showPass ? "ri-eye-off-fill" : "ri-eye-fill"}></i>
                    </span>
                    {errors.password && (
                      <div className="text-danger sf-field-error">{errors.password.message}</div>
                    )}
                  </div>

                  {/* Confirm Password */}
                  <div className="form-group mb-3 position-relative">
                    <label className="twm-field-label">
                      Confirm Password <span className="sf-required">*</span>
                    </label>
                    <input
                      name="password_confirmation"
                      type={showConfirm ? "text" : "password"}
                      className={`form-control ${errors.password_confirmation ? "is-invalid" : ""}`}
                      ref={register({
                        required: "Please confirm your password",
                        validate: (v) =>
                          v === getValues("password") || "Passwords do not match",
                      })}
                    />
                    <span className="showPassword" onClick={() => setShowConfirm(!showConfirm)}>
                      <i className={showConfirm ? "ri-eye-off-fill" : "ri-eye-fill"}></i>
                    </span>
                    {errors.password_confirmation && (
                      <div className="text-danger sf-field-error">
                        {errors.password_confirmation.message}
                      </div>
                    )}
                  </div>

                  {/* Terms */}
                  <div className="form-group mb-4">
                    <div className="sf-terms-row">
                      <input
                        type="checkbox"
                        name="terms_condition"
                        id="reg-acceptTerms"
                        defaultValue="Y"
                        className={`form-check-input ${errors.terms_condition ? "is-invalid" : ""}`}
                        ref={register({ required: "You must accept the terms" })}
                      />
                      <label htmlFor="reg-acceptTerms" className="sf-terms-label">
                        I agree to the Solid Future{" "}
                        <Link
                          to="/pages/terms-and-conditions"
                          target="_blank"
                          className="site-text-primary"
                        >
                          Terms &amp; Condition
                        </Link>{" "}
                        and{" "}
                        <Link
                          to="/pages/privacy-policy"
                          target="_blank"
                          className="site-text-primary"
                        >
                          Privacy Policy
                        </Link>
                        .
                      </label>
                    </div>
                    {errors.terms_condition && (
                      <div className="text-danger sf-field-error">
                        {errors.terms_condition.message}
                      </div>
                    )}
                  </div>

                  {/* Submit */}
                  <button type="submit" className="site-button">
                    Create Seeker Account
                  </button>

                </form>

                {/* Already have account */}
                <p className="twm-new-register" style={{ marginTop: "18px" }}>
                  Already have an Account ?{" "}
                  <button
                    type="button"
                    className="twm-backto-login"
                    data-bs-target="#sign_up_popup2"
                    data-bs-toggle="modal"
                    data-bs-dismiss="modal"
                  >
                    Log In
                  </button>
                </p>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
